export const query = `query getCategoryInitialData($externalId: String!, $currentCategoryId: String!, $withCategories: Boolean = true) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    categories @include(if: $withCategories) {
      list {
        id
        name
        slug
        visible
        parentCategoryId
        parentCategoryIndex
      }
    }
    category(categoryId: $currentCategoryId) {
      promotions {
        position
      	promotion {
          id
          destinationUrl
          media {
            image {
              id
              url
              height
              width
              altText
            }
          }
        }
      }
    }
    allProductsCategoryId
  }
}
`;
